import React, { useMemo } from "react";
import classNames from "classnames";
import { getNthColor } from "@common/helpers/colors";
import { Entity } from "@common/types/entity";
import { useUser } from "@hooks/useUser";
import { ProfileFormSchema } from "@components/onboarding/useEntityProfileFormConfig";
import { Avatar } from "@design-system/Avatar/Avatar";
import animation from "../../layout/OnboardingLayout.module.scss";
import styles from "./WorkspacePreview.module.scss";

interface WorkspacePreviewProps {
    entity?: Entity;
    formValues?: Partial<ProfileFormSchema>;
}

export const WorkspacePreview: React.FC<WorkspacePreviewProps> = ({
    entity,
    formValues,
}) => {
    const user = useUser();

    const displayEntityName = useMemo(() => {
        const trimmedFormName = formValues?.name?.trim();
        return (
            (trimmedFormName && trimmedFormName.length > 0
                ? trimmedFormName
                : null) ??
            entity?.name ??
            "Internet Money"
        );
    }, [formValues?.name, entity?.name]);

    const displayUserName = useMemo(() => {
        const firstName = formValues?.firstName ?? user.firstName;
        const lastName = formValues?.lastName ?? user.lastName;
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || "Matt Peterson";
    }, [
        formValues?.firstName,
        formValues?.lastName,
        user.firstName,
        user.lastName,
    ]);

    return (
        <div className={classNames(styles.workspacePreview, animation.fadeIn1)}>
            <section className={classNames(styles.entities, animation.fadeIn2)}>
                <div className={styles.entity}>
                    <Avatar
                        name={displayEntityName}
                        color={getNthColor(2)}
                        shape="square"
                        size="xs"
                        aria-hidden
                    />{" "}
                    {displayEntityName}
                </div>
                <div className={styles.entity}>
                    <Avatar
                        name={displayUserName}
                        shape="square"
                        variant="outline"
                        tone="neutral"
                        size="xs"
                        aria-hidden
                    />
                    {displayUserName}
                </div>
            </section>
        </div>
    );
};
